import React from 'react';
import { useIntl } from 'react-intl';

import { Graphic, Period } from '../../../hooks/types';
import { Charts } from '../../ui';
import { GraphicTitle, GraphicWrapper } from '../style';

export type UpdateAnalyticsProps = {
  date: Period;
  loginProject: string | null;
  country: string | null;
};

type Props = {
  users: Graphic | null;
  error: boolean;
};

export const getState = (body: Graphic | null, error: boolean): 'fail' | 'empty' | 'normal' => {
  if (error) {
    return 'fail';
  }
  if (!body || body.points.length === 0) {
    return 'empty';
  }
  return 'normal';
};

const ActiveUsersGraphic = ({ users, error }: Props): JSX.Element => {
  const intl = useIntl();

  // if (error) {
  //   return (
  //     <GraphicWrapper>
  //       <GraphicTitle data-test-id="analytics-page__active-users__title">
  //         {intl.formatMessage({ id: 'analytics.charts.active-users' })}
  //       </GraphicTitle>
  //       <Charts
  //         name="active-users"
  //         state="fail"
  //         options={{
  //           chart: {
  //             height: 422
  //           }
  //         }}
  //       />
  //     </GraphicWrapper>
  //   );
  // }
  //
  // if (!users) {
  //   return <></>;
  // }

  const usersStep = users ? Math.floor(users.points.length / 15) + 1 : 0;

  // Make space at chart sides
  const usersMin = users ? -Math.floor(users.points.length / 15) : 0;
  let usersMax = users ? users.points.length - 1 + Math.floor(users.points.length / 30) : 0;
  if (users && usersMax !== users.points.length - 1 && (usersMax - usersMin) % usersStep === 0) {
    usersMax -= 1;
  }

  return (
    <GraphicWrapper>
      <GraphicTitle data-test-id="analytics-page__active-users__title">
        {intl.formatMessage({ id: 'analytics.charts.active-users' })}
      </GraphicTitle>
      <Charts
        name="active-users"
        state={getState(users, error)}
        options={{
          chart: {
            height: 422
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              softThreshold: false
            }
          },
          xAxis: {
            categories: users
              ? users.points.map((p) => {
                  const d = new Date(p.key);
                  return intl.formatDate(d, {
                    month: 'numeric',
                    day: 'numeric',
                    year: '2-digit'
                  });
                })
              : [],
            min: usersMin,
            max: usersMax,
            showFirstLabel: usersMin === 0,
            showLastLabel: usersMax !== 0,
            labels: {
              step: usersStep,
              align: 'center'
            }
          },
          yAxis: [
            {
              showLastLabel: false,
              offset: -20,
              labels: {
                y: -6,
                align: 'left'
              },
              title: {
                text: intl.formatMessage({ id: 'analytics.charts.active-users.legend' }),
                align: 'high',
                offset: 0,
                rotation: 0,
                x: -20,
                textAlign: 'left',
                reserveSpace: false,
                y: -6
              },
              minRange: 4,
              min: 0
            }
          ],
          series: [
            {
              name: intl.formatMessage({ id: 'analytics.charts.active-users.plot' }),
              colorIndex: 1,
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              data: users ? users.points.map((p) => p.value) : []
            }
          ]
        }}
      />
    </GraphicWrapper>
  );
};

export default ActiveUsersGraphic;
